import React, { Component } from 'react';

// eslint-disable-next-line
class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <p className="footer__credits">rluijten &copy; 2016</p>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./client/js/components/shared/Footer.js